/* テンプレート一覧画面 */
import React, { useState, useEffect, useCallback } from 'react';
import { createRoot } from 'react-dom/client';
import axios from '../axios';
import LoadingModal from '../molecules/LoadingModal';
import { handleBrowzerBack } from '../BrowzerBack';
import { scrollPageTop } from '../Scroll';
import ResultTemplateList from '../molecules/ResultTemplateList';

const TemplateList: React.FC = () => {
  const [templates, setTemplates] = useState([]);
  const [is_loading, setIsLoading] = useState(false);
  // 検索パラメータの初期化

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowzerBack();
    const getTemplate = async () => {
      try {
        //ローディング画面表示
        setIsLoading(true);
        const response = await axios.get('api/templates/get_template_list');
        setTemplates(response.data.templates);
      } catch (error) {
        console.error(error.message);
      } finally {
        //画面トップに遷移
        scrollPageTop();
        //ローディング画面非表示
        setIsLoading(false);
      }
    };
    getTemplate();
  }, []);

  /**
   * テンプレートIDのリンク押下時の処理
   */
  const handleClickTemplateId = useCallback((event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    const setReseptionDetails = async () => {
      try {
        //ローディング画面表示
        setIsLoading(true);
        const response = await axios.get(event.currentTarget.href);
        const redirect_url = response.request.responseURL.trim() || '/templates/list';
        location.href = redirect_url;
      } catch (exception) {
        console.error(exception);
      } finally {
        //ローディング画面非表示
        setIsLoading(false);
      }
    };
    setReseptionDetails();
  }, []);

  return (
    <div className="container">
      <ResultTemplateList templates={templates} handleClickTemplateId={handleClickTemplateId} />
      {/* ローディング画面 */}
      <LoadingModal show={is_loading} />
    </div>
  );
};

const container = document.getElementById('template-list');
if (container) {
  const root = createRoot(container);
  root.render(<TemplateList />);
}
